
import { TIconField, TLinkField, TSitecoreContext, TStringField } from '../../../types/types';
import { TDownloadBrochuresProps, TDownloadBrochureFields, TBrochureCardField } from '../types/downloadBrochures.types';

export class ProductDownloadBrochureModel {
  private readonly fields: TDownloadBrochureFields;
  private readonly context: TSitecoreContext;

  constructor(props: TDownloadBrochuresProps) {
    this.context = props.sitecoreContext;
    this.fields = props?.fields || null;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get eyebrow(): TStringField | undefined {
    return this.fields?.eyebrow;
  }

  get subHeading(): TStringField | undefined {
    return this.fields?.subHeading;
  }

  get ctaLink(): TLinkField | undefined {
    return this.fields?.ctaLink;
  }

  get shareIcon(): TIconField | undefined {
    return this.fields?.shareIcon;
  }

  get downloadIcon(): TIconField | undefined {
    return this.fields?.downloadIcon;
  }

  get viewIcon(): TIconField | undefined {
    return this.fields?.viewIcon;
  }

  get brochureCards(): TBrochureCardField[] {
    return this.fields?.items || [];
  }

  get currentPageUrl(): string {
    return this.context?.currentPageUrl ?? '';
  }

}
